import { GWInsured } from './gw-insured.model';

import { GWCarRental } from './gw-car-rental.model';
import { GWDestination } from './gw-destination.model';
import { GWBaseQuote } from './gw-base-quote.model';

import { GWFlight } from './gw-flight.model';
import { GWAttribute } from './gw-attribute.model';


export class GWInsuredEvent {
    public id: number;
    public agencyCode: string;
    public agentCode: string;
    public externalCustomerId: string;
    public status: string;
    public addressLine1: string;
    public addressLine2: string;
    public city: string;
    public stateIso2: string;
    public postalCode: string;
    public countryIso2: string;
    public purchasedQuoteId: number;
    public purchaseDate: string;
    public initialContactDate: string;
    public expirationDate: string;
    public expirationMessage: string;
    public startDate: string;
    public startDateTimezone: string;
    public endDate: string;
    public endDateTimezone: string;
    public initialDepositDate: string;
    public finalDepositDate: string;
    public totalInsurableCost: number;
    public insureds: GWInsured[];
    public flights: GWFlight[];
    public carRentals: GWCarRental[];
    public destinations: GWDestination[];
    public quotes: GWBaseQuote[];
    public attributes: GWAttribute[];
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/gw-insured-event.model.ts